import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import VueMathjax from 'vue-mathjax'
import App from './App.vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false

Vue.use(Router)
Vue.use(VueAxios, axios)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueApexCharts)
Vue.use(VueMathjax)

// eslint-disable-next-line
Vue.component('apexchart', VueApexCharts)
const Welcome = () => import('./components/Welcome.vue')
const AlternativeOfferings = () => import('./components/AlternativeOfferings.vue')
const BlockstreamMiningNote = () => import('./components/BlockstreamMiningNote.vue')
const TitanCell1 = () => import('./components/TitanCell1.vue')
const TitanCell2 = () => import('./components/TitanCell2.vue')
const TitanCell4 = () => import('./components/TitanCell4.vue')
const InvestorReturnsOverview = () => import('./components/InvestorReturnsOverview.vue')
const InvestorUnrealizedReturns = () => import('./components/InvestorUnrealizedReturns.vue')
const Ustbl = () => import('./components/Ustbl.vue')
const BfxsaIndex = () => import('./components/BfxsaIndex.vue')

const router = new Router({
  routes: [
    { path: '/alternative-offerings', component: AlternativeOfferings },
    { path: '/bfxsa-index', component: BfxsaIndex },
    { path: '/bmn2', component: BlockstreamMiningNote },
    { path: '/ctrl-alt-cell-I', component: TitanCell1 },
    { path: '/ctrl-alt-cell-II', component: TitanCell2 },
    { path: '/ctrl-alt-cell-IV', component: TitanCell4 },
    { path: '/ustbl', component: Ustbl },
    { path: '/investor-returns', component: InvestorReturnsOverview },
    { path: '/investor-unrealized-returns', component: InvestorUnrealizedReturns },
    { path: '/', component: Welcome }
  ]
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
